import { useNavigateTo } from 'hooks/useNavigateTo'
import { SORT_BY_RANDOM } from '../constant'
import { SchemaCmsSectionShow } from 'api'

const VIDEO_BOX_TEMPLATE_WITH_VERTICAL_VIDEO = ['8', '9', '14', '15', '16', '17', '18']
type ViewMoreType = 'video' | 'comic' | 'novel' | 'short'

interface ViewMoreInfo extends Omit<SchemaCmsSectionShow, 'type'> {
  isVideoSortByRandom?: boolean
  type: ViewMoreType // override type to fit enum string
}

export default function useOpenModal(info: ViewMoreInfo) {
  const { navigateToViewMore } = useNavigateTo()
  const openViewMoreModal = () => {
    const category_ids = info?.video_category?.join(',')
    const actor_ids = info?.video_actor?.join(',')
    const tag_ids = info?.video_tag?.join(',')
    const region_ids = info?.video_region_ids?.join(',')
    const templateType = info?.template_id

    const params = {
      isVerticalVideoBox: VIDEO_BOX_TEMPLATE_WITH_VERTICAL_VIDEO.includes(templateType),
      // 使用大圖的 VideoLargeBox
      isLargeVideoBox: true,
      category_ids: category_ids,
      actor_ids: actor_ids,
      tag_ids: tag_ids,
      region_ids: region_ids,
      // producer_id: info?.video_producer_id,
      producer_ids: Array.isArray(info?.video_producer_ids) ? info?.video_producer_ids?.join(',') : '',
      // video的sortby不支援random，因此這邊在早期的code內設定先把他轉為updated_at
      sortby: info?.isVideoSortByRandom ? 'updated_at' : info?.video_sortby,
      // 將用於viewMore內容之中表示需要隨機排序
      random: info?.isVideoSortByRandom,
      ...(info.video_sortby === 'days_hot' ? { hot_days: info.hot_days, hot_days_start: info.hot_days_start } : {}),
      ...(info.video_sortby === 'month_hot' ? { hot_month: info.hot_month } : {}),
      ...(info.video_sortby === 'year_hot' ? { hot_year: info.hot_year } : {}),
      payment_type: info?.video_payment_type,
      ...(info.type === 'short'
        ? {
            uploader_id: info?.video_uploader_id,
          }
        : {}),
      ...(info.type === 'comic'
        ? {
            serial: info?.serial,
          }
        : {}),
    }

    navigateToViewMore({
      params,
      headerTitle: info?.title,
      type: info.type,
    })
  }

  return {
    openViewMoreModal,
  }
}

interface RankInfo {
  title: string
  infoList: any[]
  type: 'video' | 'short' | 'comic' | 'novel'
  tabIndex?: number
}

//聚合版面
export function useOpenRankModal({ title, infoList, type, tabIndex }: RankInfo) {
  const { navigateToRankViewMore } = useNavigateTo()
  const openViewMoreModal = () => {
    const list = infoList.map((info: any) => {
      // 按原本的機制調整資料參數
      const category_ids = info?.video_category?.join(',')
      const actor_ids = info?.video_actor?.join(',')
      const tag_ids = info?.video_tag?.join(',')
      const region_ids = info?.video_region_ids?.join(',')
      const templateType = info?.template_id

      const params = {
        special_search: 1, // 排行榜
        isVerticalVideoBox: VIDEO_BOX_TEMPLATE_WITH_VERTICAL_VIDEO.includes(templateType as string),
        // 使用大圖的 VideoLargeBox
        isLargeVideoBox: true,
        category_ids: category_ids,
        actor_ids: actor_ids,
        tag_ids: tag_ids,
        region_ids: region_ids,
        // producer_id: info?.video_producer_id,
        producer_ids: Array.isArray(info?.video_producer_ids) ? info?.video_producer_ids?.join(',') : '',
        // video的sortby不支援random，因此這邊在早期的code內設定先把他轉為updated_at
        sortby: info?.video_sortby === SORT_BY_RANDOM ? 'updated_at' : info?.video_sortby,
        // 將用於viewMore內容之中表示需要隨機排序
        random: info?.isVideoSortByRandom,
        payment_type: info?.video_payment_type,
        ...(info?.video_sortby === 'days_hot' ? { hot_days: info.hot_days, hot_days_start: info.hot_days_start } : {}),
        ...(info?.video_sortby === 'month_hot' ? { hot_month: info.hot_month } : {}),
        ...(info.video_sortby === 'year_hot' ? { hot_year: info.hot_year } : {}),
        ...(info.type === 'short'
          ? {
              uploader_id: info?.video_uploader_id,
            }
          : {}),
        ...(info.type === 'comic'
          ? {
              serial: info?.serial,
            }
          : {}),
      }
      return {
        title: info.title,
        params,
      }
    })

    navigateToRankViewMore({
      infoList: list,
      headerTitle: title,
      type: type,
      tabIndex: tabIndex,
    })
  }

  return {
    openViewMoreModal,
  }
}
